import { FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import { useGlobalDispatch } from '../../common/context/AppContext';
import { SCREEN_NAME } from '../../common/interface/IAppProvider';
import { useStyles } from './OnsaBanner.styles';

export type Tvariant = 'box' | 'top';

export interface IOnsaBannerProps {
    variant: Tvariant;
    body: string;
    enableToggle: boolean;
    header?: string;
}

const OnsaBanner: FunctionComponent<IOnsaBannerProps> = (props): JSX.Element => {
    const appDispatch = useGlobalDispatch();
    const baseClass = useStyles();
    const header = props.header || '';
    const bodyHtml = { __html: props.body };

    const toggle = () => {
        if (props.enableToggle) {
            appDispatch({ type: SCREEN_NAME.SHOW_BANNER_OVERLAY, payload: true });
        }
    };

    return (
        <div className={`${baseClass.wrapper} ${baseClass[props.variant]}`}>
            {props.variant === 'box' && <div className={baseClass.header}>{header}</div>}
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <span onClick={toggle} className={baseClass.message} dangerouslySetInnerHTML={bodyHtml} />
            </Grid>
        </div>
    );
};

export default OnsaBanner;
